import React from 'react';
import './PolicyPage.css';

const Contact: React.FC = () => (
  <main className="policy-page">
    <h1>Contact Us</h1>
    <p>We are here to help with orders, payments, delivery, returns, and product questions.</p>
    <div className="contact-card">
      <p><strong>Email:</strong> <a href="mailto:hello@gimbiyastore.com">hello@gimbiyastore.com</a></p>
      <p><strong>Support:</strong> 07065012438</p>
      <p><strong>Logistics:</strong> 08162437615</p>
      <p><strong>Head Office:</strong> 07010110977</p>
      <p><strong>Location:</strong> Zango, Zaria, Kaduna State, Nigeria</p>
      <p><strong>Delivery:</strong> Within 24 hours in Zaria/Kaduna; 1–3 days outside.</p>
    </div>
    <p>When contacting us about an order, include your order reference and a short description of the issue. Do not send card numbers, PINs, CVVs, OTPs, or passwords by email or chat.</p>
  </main>
);
export default Contact;
